import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'hu',
    supportedLngs: ['hu', 'en'],
    debug: true,
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
    },
    react: {
        useSuspense: true, // Suspense for loading translations
    },
    backend: {
      loadPath: `${process.env.REACT_APP_SERVER_URL}/translations/{{lng}}`,
      allowMultiLoading: false,
    },
    interpolation: {
      escapeValue: false,
    },
    load: 'languageOnly',
    saveMissing: true,   
  });

export default i18n;